import { render, staticRenderFns } from "./dr-autocomplete-elem.vue?vue&type=template&id=3fd66348"
import script from "./dr-autocomplete-elem.vue?vue&type=script&lang=js"
export * from "./dr-autocomplete-elem.vue?vue&type=script&lang=js"
import style0 from "./dr-autocomplete-elem.vue?vue&type=style&index=0&id=3fd66348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports